// 下单
<template>
    <div>
        <van-nav-bar
            title="单据信息"
            left-text="返回"
            left-arrow
            @click-left="clickback"/>

        <OrderItem :item="data"/>
                
        <van-cell-group v-if="data.deliver_style==0">
            <van-cell title="预约到店提货安装时间" icon="clock-o" />
            <van-cell :title="data.plan_date + ' ' + data.plan_time_name" />
        </van-cell-group>

        <van-cell-group v-if="data.deliver_style==1">
            <van-cell title="快递到家" icon="clock-o" />
            <van-cell :title="data.area_name" :label="data.deliver_address" />
        </van-cell-group>

        <van-cell-group>
            <van-cell title="下单时间" :value="data.create_date" />
            <van-cell title="品牌" :value="data.brand_name" />
            <van-cell title="特征" :value="data.prd_spc" />
            <van-cell title="条码" :value="data.barcode" />
            <van-cell title="类别" :value="data.cls_name" />
            <van-cell title="子类" :value="data.cls1_name" />
        </van-cell-group>

        <van-cell title="说明" :value="data.details"/>

        <van-loading vertical v-if="loading"/>

        <van-goods-action v-if="data.state in [0,1,2]">
            <van-goods-action-icon icon="null" text=""/>
            <van-goods-action-icon icon="" text=""/>
            <van-goods-action-icon icon="" text=""/>
            <van-goods-action-button v-if="data.state==0" type="danger" text="取消" @click="updateState(0)"/>
            <van-goods-action-button v-if="data.state==0" type="primary" text="支付" @click="payItem(data.id)"/>
            <van-goods-action-button v-if="data.state !=0" type="primary" text="完成" @click="updateState(3)"/>
        </van-goods-action>
    </div>
</template>

<script>
import {
    NavBar,
    Swipe,
    SwipeItem,
    Card,
    Panel,
    CellGroup,
    Cell,
    Field,
    Popup,
    CouponCell,
    CouponList,
    TreeSelect,
    SubmitBar,
    Stepper,
    GoodsAction,
    GoodsActionIcon, 
    GoodsActionButton,
    Loading
} from 'vant'
import OrderItem from '@/view/directsell/components/orderitem'
import { DirectSellOrderApi } from '@/api/directsell'
import { getCurDate, formatDate } from '@/utils/dateutils'
import { CurShopInfoApi, UnifiedDirectSellOrderApi } from '@/api/market'
import wxshare from "@/utils/wxshare"

export default {
    components: {
        [NavBar.name]: NavBar,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Card.name]: Card,
        [Panel.name]: Panel,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [Field.name]: Field,
        [CouponCell.name]: CouponCell,
        [CouponList.name]: CouponList,
        [Popup.name]: Popup,
        [TreeSelect.name]: TreeSelect,
        [SubmitBar.name]: SubmitBar,
        [Stepper.name]: Stepper,
        [GoodsAction.name]: GoodsAction, 
        [GoodsActionIcon.name]: GoodsActionIcon,
        [GoodsActionButton.name]: GoodsActionButton,
        [Loading.name]: Loading,
        OrderItem
    },
    data() {
        return {
            soure: '',
            loading: false,
            data: {
                id: this.$route.params.id,
                delivery_style: true,
                plan_date: this.$moment(getCurDate()).format('YYYY-MM-DD'),
                plan_time: 0,
                plan_time_name: '',
                details: null,
                vip_name: '',
                shop_name: '',
                deliver_style_name: '',
                order_state_name: '',
                pay_state_name: '',
                area_name: '',
                address: '',
                imgurl: '',
                prd_name: '',
                version_name: '',
                prd_spc: '',
                cls_name: '',
                cls1_name: '',
                barcode: '',
                wx_paycode: '',
                wx_pay_date: '',
                advise_price: '',
                qty: '',
                brand_name: ''
            }
        }
    },
    mounted: function() { 
        this.getData()
        this.getShopInfo()
    },
    methods: {
        getData() {
            var that = this
            that.loading = true
            this.axios.get(DirectSellOrderApi + `${this.data.id }`).then((ret) => {
                that.loading = false
                that.data = ret
                that.data.create_date = formatDate(that.data.create_date)
                console.log(ret)
            })
        },
        getShopInfo() {
            var that = this
            that.axios.get(CurShopInfoApi).then((ret) => {
                that.curshopinfo = {
                    city: ret.details.city?ret.details.city:'',
                    area: ret.details.area?ret.details.area:'',
                    address: ret.details.address?ret.details.address:'',
                    contact_name: ret.details.contact_name?ret.details.contact_name:'',
                    contace_mobile: ret.details.contace_mobile?ret.details.contace_mobile:''
                }
            })
        },
        updateState(state) {
            var params = {}
            if (state == 0) { // 撤销单据
                params = {
                    action: 0
                }
            } else { // 完成
                params = {
                    action: 3
                }
            }
            this.loading = true
            var that = this
            that.axios.patch(DirectSellOrderApi + that.data.id + '/', params).then((ret) => {
                that.loading = false
                if (ret.flag) {
                    this.$router.push('/nt/directsellslist')
                }
            }).catch((ex) => {
                that.loading = false
                console.log(ex)
            })
        },
        payItem(order_id) {
            console.log('zhifu')
            console.log(order_id)
            this.payment(order_id)
        },
        payment(order_id){
            wxshare.getJSSDK()
            var that = this
            const paymentdata = {
                "order": order_id
            }
            console.log(paymentdata)
            that.axios.post(UnifiedDirectSellOrderApi, paymentdata).then((ret) => {
                window.wx.ready(function(){
                    window.wx.chooseWXPay({
                        timestamp: ret.timeStamp, 
                        // 支付签名随机串，不长于 32 位
                        nonceStr: ret.nonceStr, 
                        package: ret.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                        signType: ret.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                        paySign: ret.paySign, // 支付签名
                    success: function(res) {
                        console.log(res)
                        console.log('支付成功')
                        that.$router.push(that.backurl)
                    },
                    fail: function(res) {
                        console.log(res)
                        console.log('支付失败')
                    },
                    complete: function(res) {
                        console.log(res, 'complete')
                    }
                    })
                })
            })

        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push('/nt/directsellslist')
            }
        }
    }
}
</script>